export const PRIMARY_FONT = 'avenir'
